module.exports = __webpack_public_path__ + "img/dis-yiwancheng.97c18eff.svg";